/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiAcceptRoomInvitationRequestFromJSON(json) {
    return StreemApiAcceptRoomInvitationRequestFromJSONTyped(json, false);
}
export function StreemApiAcceptRoomInvitationRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'acceptedByUserSid': !exists(json, 'accepted_by_user_sid') ? undefined : json['accepted_by_user_sid'],
    };
}
export function StreemApiAcceptRoomInvitationRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'accepted_by_user_sid': value.acceptedByUserSid,
    };
}
//# sourceMappingURL=StreemApiAcceptRoomInvitationRequest.js.map